var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5 0.5H4.5C1.94667 0.5 0.5 1.94667 0.5 4.5V11.5C0.5 14.0467 1.94 15.5 4.5 15.5H11.5C14.0533 15.5 15.5 14.0467 15.5 11.5V4.5C15.5 1.94667 14.0533 0.5 11.5 0.5Z",
    fill: "#36CA8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4903 8.53125H8.56214V10.4427C8.56214 10.7505 8.31046 11 8 11C7.68954 11 7.43786 10.7505 7.43786 10.4427V8.53125H5.50966C5.22007 8.50152 5 8.25961 5 7.97099C5 7.68237 5.22007 7.44046 5.50966 7.41073H7.43182V5.50524C7.4618 5.21816 7.70584 5 7.99698 5C8.28812 5 8.53215 5.21816 8.56214 5.50524V7.41073H10.4903C10.7799 7.44046 11 7.68237 11 7.97099C11 8.25961 10.7799 8.50152 10.4903 8.53125Z",
    fill: "#36CA8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.a144215852d41328cec28de9353804b2.svg";
export { ForwardRef as ReactComponent };